import PropTypes from 'prop-types'
import React, { useEffect } from 'react'

import { getCanRenderIconLayer } from './useWebGLSupport'
import WebGLLayerErrorBoundary from './WebGLLayerErrorBoundary'

// Boundary-wrapped so a post-mount throw degrades to the same `fallback` a failed probe does.
const WebGLMarkerSurface = ({ enabled, componentName, fallback, children }) => {
  const canRender = enabled && getCanRenderIconLayer()

  useEffect(() => {
    if (enabled && !canRender) {
      // eslint-disable-next-line no-console
      console.warn(`[${componentName}] WebGL IconLayer probe failed; rendering DOM markers`)
    }
  }, [enabled, canRender, componentName])

  if (!canRender) return fallback
  return <WebGLLayerErrorBoundary fallback={fallback}>{children}</WebGLLayerErrorBoundary>
}

WebGLMarkerSurface.propTypes = {
  enabled: PropTypes.bool.isRequired,
  componentName: PropTypes.string.isRequired,
  fallback: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
}

export default WebGLMarkerSurface
